<script>
   import { getContext } from 'svelte';

   /** @type {Writable<boolean>} */
   const storeVisible = getContext('#visible');
</script>

<button on:click={() => $storeVisible = !$storeVisible}
        on:pointerdown|stopPropagation={() => null}>
   <svg width=16 height=16 viewBox="0 0 16 16" fill=none>
      <path d="M15.7824 13.833L12.6666 10.7177C12.5259 10.5771 12.3353 10.499 12.1353 10.499H11.6259C12.4884 9.39596 13.001 8.00859 13.001 6.49937C13.001 2.90909 10.0914 0 6.50048 0C2.90959 0 0 2.90909 0 6.49937C0 10.0896 2.90959 12.9987 6.50048 12.9987C8.00996 12.9987 9.39756 12.4863 10.5008 11.6239V12.1332C10.5008 12.3332 10.5789 12.5238 10.7195 12.6644L13.8354 15.7797C14.1292 16.0734 14.6042 16.0734 14.8948 15.7797L15.7793 14.8954C16.0731 14.6017 16.0731 14.1267 15.7824 13.833ZM6.50048 10.499C4.29094 10.499 2.50018 8.71165 2.50018 6.49937C2.50018 4.29021 4.28781 2.49976 6.50048 2.49976C8.71001 2.49976 10.5008 4.28708 10.5008 6.49937C10.5008 8.70852 8.71314 10.499 6.50048 10.499Z" fill="var(--color-text)"></path>
   </svg>
</button>

<style>
   button {
      width: 35px;
      height: 35px;

      background: transparent;
      border-radius: 50%;
      cursor: pointer;
      line-height: 0;
   }
</style>